import React, { useEffect, useState } from 'react';
function OfferAttention(props) {

	const [offerAttentionMessage, setOfferAttentionMessage] = useState('');
	useEffect(() => {
		// メッセージ切り替え
		setMessage();
	}, [props.language]);

	useEffect(() => {
		// 注意書き文言を表示する
		setMessage();
	}, [props.customize]);


	const setMessage = () => {
		getTopics();
	}

	const getTopics = async () => {
		try {
			const url = process.env.REACT_APP_API_DIR_URL + `v1/static/offer-attention`;
			fetch(url)
			.then(response => response.json())
			.then(data => {
				//props.language en_US or ja_JP
				const topics = (props.language === 'ja_JP') ? '' + data.jp : '' + data.en ;
				setOfferAttentionMessage(topics);
			})
			.catch(error => {
				console.log(error);
			});
		} catch (error) {
			console.error(error);
		}
	}

	return (
		<>
			<div className="detail-body__attention">
				<pre className="whitespace-pre-wrap">
					{offerAttentionMessage}
				</pre>
			</div>
		</>
	);
}

export default OfferAttention;
